import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./button.module.scss"; // Import SCSS module

const Button = ({ onClick, variant, disabled, className, children, icon, iconSize, size, id = "" }) => {
  const buttonClasses = classNames(
    styles["btn"],
    {
      [styles["btn-primary"]]: variant === "primary",
      [styles["btn-primaryWithIcon"]]: variant === "primaryWithIcon",
      [styles["btn-primaryLightWithIcon"]]: variant === "primaryLightWithIcon",
      [styles["btn-secondary"]]: variant === "secondary",
      [styles["btn-secondaryWithIcon"]]: variant === "secondaryWithIcon",
      [styles["btn-primaryLink"]]: variant === "primaryLink",
      [styles["btn-secondaryLink"]]: variant === "secondaryLink",
      [styles["size-medium"]]: size === "medium",
      [styles["size-small"]]: size === "small",
      [styles["size-large"]]: size === "large",
    },
    className,
    "d-flex align-items-center justify-content-center"
  );

  const iconClasses = classNames({ [styles["icon-small"]]: iconSize === "small" }, { [styles["icon-medium"]]: iconSize === "medium" }, { [styles["icon-large"]]: iconSize === "large" });

  return (
    <button className={buttonClasses} onClick={onClick} disabled={disabled} id={id}>
      {icon && <img className={iconClasses} src={icon} alt="icon" />}
      {children}
    </button>
  );
};

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["primary", "primaryWithIcon", "primaryLightWithIcon", "secondary", "secondaryWithIcon", "primaryLink", "secondaryLink"]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  iconSize: PropTypes.oneOf(["small", "medium", "large"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  border: PropTypes.bool,
};

Button.defaultProps = {
  variant: "primary",
  disabled: false,
  className: "",
  icon: null,
  iconSize: "small",
  size: "medium",
  border: false,
};

export default Button;
